import store from "./store";
import { actions } from "../app/modules/Auth/_redux/authRedux";
import message from "../utils/message";

export const requestRejectInterceptor = err => Promise.reject(err)
export const requestInterceptor = store => config => {
    const {
        auth: { authToken }
    } = store.getState();

    if (authToken && config?.headers?.[config?.method]?.['Content-Type'] !== "application/xml") {
        config.headers.Authorization = `Bearer ${authToken}`;
    }

    if (process.env.REACT_APP_BASE_API_URL.match(/\/DUMMY/) && !config.url.match(/\/api/)) {
        config.url = `${config.url}.json`
        config.method = 'GET'
    }

    return config;
}

export const responseRejectInterceptor = err => {
    if (err.response) {
        const { status, config } = err.response;
        
        // Handle 403 Forbidden from tenant info endpoint
        if (status === 403 && config.url === '/api/sys/tenant/info') {
            const message = "<p>Dear Customer,</p>\n<p>Thank you for using UniFi! Based on our record, you no longer have an Active license since your contract has already expired and has not renewed.  If you wish to continue using UniFi, please send an email to <a href=\"mailto:Accounts@finansys.com\" target=\"_blank\">accounts@finansys.com</a>.</p>\n"
            const errorMessage = err.response.data?.data || message;
            if (errorMessage) {
                // Redirect to forbidden page with custom message
                window.location.href = `/403?message=${encodeURIComponent(errorMessage)}`;
                return;
            }
        }
        
        if (status === 401) {
            store.dispatch(actions.logout())
        }
        if (status === 504) {
            message.error("Request timeout")
        }
    }
    if (err.code === 'ECONNABORTED') {
        message.error(err.message)
    }
}

export const responseInterceptor = response => response

export default function setupAxios(axios, store) {
  axios.interceptors.request.use(requestInterceptor(store));

  axios.interceptors.response.use(
    responseInterceptor,
    responseRejectInterceptor
  );
}
